export default {
  "content": "<path d=\"M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.54 7.4l-3.98 5.47c-.18.25-.58.11-.56-.2l.24-3.8.02-.41H4.71c-.25 0-.4-.28-.26-.49l3.39-4.84c.17-.25.56-.12.56.18v3.6h2.89c.26 0 .4.29.25.49z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};